import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60CancelCircle = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='-2 -2 63 63'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M30.000,59.999 C13.458,59.999 -0.000,46.540 -0.000,29.999 C-0.000,13.457 13.458,-0.001 30.000,-0.001 C46.542,-0.001 60.000,13.457 60.000,29.999 C60.000,46.540 46.542,59.999 30.000,59.999 ZM30.000,1.999 C14.561,1.999 2.000,14.560 2.000,29.999 C2.000,45.439 14.561,57.999 30.000,57.999 C45.439,57.999 58.000,45.439 58.000,29.999 C58.000,14.560 45.439,1.999 30.000,1.999 ZM40.707,40.706 C40.512,40.901 40.256,40.999 40.000,40.999 C39.744,40.999 39.488,40.901 39.293,40.706 L30.000,31.413 L20.707,40.706 C20.512,40.901 20.256,40.999 20.000,40.999 C19.744,40.999 19.488,40.901 19.293,40.706 C18.902,40.316 18.902,39.682 19.293,39.292 L28.586,29.999 L19.293,20.707 C18.902,20.316 18.902,19.683 19.293,19.292 C19.684,18.902 20.316,18.902 20.707,19.292 L30.000,28.585 L39.293,19.292 C39.684,18.902 40.316,18.902 40.707,19.292 C41.098,19.683 41.098,20.316 40.707,20.707 L31.414,29.999 L40.707,39.292 C41.098,39.682 41.098,40.316 40.707,40.706 Z' />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60CancelCircle.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
